<script setup lang="ts">
const { t } = useI18n();
const config = useRuntimeConfig();

const phoneRaw = computed(
  () => (config.public.whatsappNumber as string) || "+995505556117"
);
const telHref = computed(() => `tel:${phoneRaw.value}`);

const phoneDisplay = computed(() => {
  const digits = phoneRaw.value.replace(/[^0-9]/g, "");
  if (digits.length === 12) {
    return `+${digits.slice(0, 3)} ${digits.slice(3, 5)} ${digits.slice(5, 8)} ${digits.slice(8)}`;
  }
  return phoneRaw.value;
});
</script>

<template>
  <section
    class="relative overflow-hidden bg-amber-50/60 dark:bg-slate-900/60 py-3 md:py-4"
  >
    <div class="container relative">
      <div class="max-w-4xl mx-auto text-center" data-reveal>
        <p
          class="text-xs uppercase tracking-[0.3em] text-red-500/90 font-semibold"
        >
          {{ t("contact_page.phone_callout_eyebrow") }}
        </p>

        <a
          :href="telHref"
          class="inline-flex items-center gap-3 md:gap-5 group"
        >
          <span
            class="flex items-center justify-center size-11 md:size-14 rounded-full bg-red-500/10 text-red-500 ring-1 ring-red-500/20 group-hover:bg-red-500 group-hover:text-white transition"
          >
            <Icon name="mdi:phone-outline" size="26px" />
          </span>
          <span
            class="font-display tracking-tight text-slate-900 dark:text-white group-hover:text-red-500 transition tabular-nums whitespace-nowrap text-2xl sm:text-3xl md:text-4xl lg:text-5xl xl:text-6xl"
          >
            {{ phoneDisplay }}
          </span>
        </a>
      </div>
    </div>
  </section>
</template>
